import React from "react";
import { DropdownProps } from "../models";
import BaseReactSelectDropdown from "./BaseReactSelectDropdown";
import { getGuestlistAccessTypeText } from "utilities/enumutils";
import { useValidateIsNotNull } from "formvalidation/hooks";

const GuestlistAccessTypeDropdown = (props: DropdownProps<server.dto.GuestlistAccessType, number>) => {
  const validation = useValidateIsNotNull({
    key: "guestlist-access-type",
    title: RESX.Guestlist.AccessType,
    value: props.value,
  });

  return <BaseReactSelectDropdown
    excludeKeys={props.excludeKeys}
    options={props.options}
    getLabel={at => getGuestlistAccessTypeText(at)}
    getValue={(t) => t.guestlistAccessTypeId}
    value={props.value}
    onChange={props.onChange}
    onEsc={props.onEsc}
    config={{
      ...props.config,
      hasError: validation.error.hasError,
    }}
  />;
};

export default GuestlistAccessTypeDropdown;